// import axios from "axios";
// import Cookies from "js-cookie"; // use this to read latest cookie
// import { useNavigate } from "react-router-dom";
// import { useCookies } from "react-cookie";

// const useAxiosInstance = () => {
//   const navigate = useNavigate();
//   const [cookies, setCookie, removeCookie] = useCookies();

//   const axiosInstance = axios.create({
//     baseURL: process.env.REACT_APP_API_URL,
//     withCredentials: true, // send cookies with requests
//   });

//   // Request interceptor
//   axiosInstance.interceptors.request.use(
//     (config) => {
//       // Always read fresh token directly from cookies
//       const token = Cookies.get("accessToken");
//       if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//       }
//       return config;
//     },
//     (error) => Promise.reject(error)
//   );

//   // Response interceptor
//   axiosInstance.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//       const originalRequest = error.config;
//       console.log({originalRequest})

//       if (error.response?.status === 401 && !originalRequest._retry) {
//         originalRequest._retry = true; // prevent infinite loop

//         try {
//           const refreshToken = Cookies.get("refreshToken");
//           // 🔄 Call refresh token API
//           const refreshResponse = await axios.post(
//             `${process.env.REACT_APP_API_URL}/auth/refresh-token`,
//             {},
//            {
//             headers: {
//               "x-refresh-token": refreshToken,
//             },
//           }
//           );

//           const { accessToken } = refreshResponse.data;

//           console.log("✅ New Access Token:");

//           // 🍪 Update cookie with new token
//           Cookies.set("accessToken", accessToken, {  expires: 1 / 3 }); // 8 hrs expiry

//           // 🔥 Update Authorization header for retry
//           originalRequest.headers.Authorization = `Bearer ${accessToken}`;

//           // Retry original request with new token
//           return axiosInstance(originalRequest);
//         } catch (refreshError) {
//           Object.keys(cookies).forEach((cookieName) => {
//             removeCookie(cookieName);
//           });
//           navigate("/login");
//           console.error("⛔ Refresh token failed:", refreshError);

//           return Promise.reject(refreshError);
//         }
//       }

//             // 👉 Handle 403 Forbidden: IP mismatch
//       if (
//         error.response?.status === 403 &&
//         error.response?.data?.message === "Forbidden: IP mismatch"
//       ) {
//         console.warn("🚫 Forbidden: IP mismatch detected");

//         // Clear all cookies
//         Object.keys(cookies).forEach((cookieName) => {
//           removeCookie(cookieName);
//         });

//         // Redirect to login page
//         navigate("/login");
//       }

//       return Promise.reject(error);
//     }
//   );

//   return axiosInstance;
// };

// export default useAxiosInstance;

import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useEffect, useMemo } from "react";
import useStore from "../store/store";
import { useAuth } from "../context/AuthProvider";

const useAxiosInstance = () => {
  const navigate = useNavigate();
  const [cookies, , removeCookie] = useCookies();
  const clearUser = useStore((state) => state.clearUser);
  const { clearContext, setContext } = useAuth();

  const axiosInstance = useMemo(() => {
    return axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      withCredentials: true, // send cookies with requests
    });
  }, []);
  // Request interceptor
  useEffect(() => {
    const requestInterceptor = axiosInstance.interceptors.request.use(
      (config) => {
        // Always read fresh token directly from cookies
        const token = Cookies.get("accessToken");

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseInterceptor = axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest?._retry) {
          originalRequest._retry = true;// prevent infinite loop

          try {
            const refreshResponse = await axios.post(
              `${process.env.REACT_APP_API_URL}/auth/refresh-token`,
              {},
              {
                withCredentials: true,
              }
            );

            const { accessToken } = refreshResponse.data;

            Cookies.set("accessToken", accessToken, {
              expires: 1 / 24,
              path: "/",
            });

            originalRequest.headers = originalRequest.headers || {};
            originalRequest.headers.Authorization = `Bearer ${accessToken}`;

            return axiosInstance(originalRequest);
          } catch (refreshError) {
            Object.keys(cookies).forEach((cookieName) => {
              removeCookie(cookieName, { path: "/" });
            });
            Cookies.remove("accessToken", { path: "/" });
            clearContext();
            clearUser();
            navigate("/login");

            return Promise.reject(refreshError);
          }
        }

        if (
          error.response?.status === 403 &&
          error.response?.data?.message === "Forbidden: IP mismatch"
        ) {
          Object.keys(cookies).forEach((cookieName) => {
            removeCookie(cookieName, { path: "/" });
          });
          Cookies.remove("accessToken", { path: "/" });
          clearContext();
          clearUser();
          navigate("/login");
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axiosInstance.interceptors.request.eject(requestInterceptor);
      axiosInstance.interceptors.response.eject(responseInterceptor);
    };
  }, [axiosInstance, cookies, navigate, removeCookie, clearContext, clearUser, setContext]);

  return axiosInstance;
};

export default useAxiosInstance;
